import { approvalStateOf, type ApprovalRide } from '../utils/rideActions';

export interface ApprovalEstimate {
  productType?: string | null;
  low: number;
  high: number;
  currency?: string;
  durationSeconds?: number | null;
  distanceMiles?: number | null;
}

export type ApprovalBanner =
  | { kind: 'decide' }
  | { kind: 'waiting'; approverName: string }
  | { kind: 'approved'; at?: string | null }
  | { kind: 'denied'; reason?: string | null }
  | { kind: 'cancelled' }
  | { kind: 'not-held' };

/** What the approval page says, from the ride and who is looking at it. */
export function approvalBannerFor(ride: ApprovalRide, viewerUserId: number | null): ApprovalBanner {
  const state = approvalStateOf(ride);
  if (state === 'none') return { kind: 'not-held' };
  if (state === 'approved') return { kind: 'approved', at: ride.approval_decided_at };
  if (state === 'denied') return { kind: 'denied', reason: ride.approval_decision_reason };
  if (ride.status !== 'new' && ride.status !== 'failed') return { kind: 'cancelled' };
  if (viewerUserId !== null && Number(ride.approval_user_id) === viewerUserId) return { kind: 'decide' };
  return { kind: 'waiting', approverName: ride.approver?.display_name || 'the approver' };
}

const money = (n: number) => `$${n.toFixed(2)}`;

export function formatFare(estimate: ApprovalEstimate | null | undefined): string | null {
  if (!estimate || !Number.isFinite(estimate.low) || !Number.isFinite(estimate.high)) return null;
  return estimate.low === estimate.high ? money(estimate.low) : `${money(estimate.low)} to ${money(estimate.high)}`;
}

export function formatTrip(estimate: ApprovalEstimate | null | undefined): string | null {
  if (!estimate) return null;
  const parts: string[] = [];
  if (Number.isFinite(estimate.distanceMiles)) parts.push(`${Number(estimate.distanceMiles).toFixed(1)} mi`);
  if (Number.isFinite(estimate.durationSeconds)) parts.push(`${Math.round(Number(estimate.durationSeconds) / 60)} min`);
  return parts.length ? parts.join(' · ') : null;
}
